'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const DiagramActionCreator = require('system/domain/action/diagram');
const Template = require('system/ui/template/modal/diagram-directory-edit.hbs');

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        'change:name': 'uploadable',
        'destroy': 'remove'
    },
    bindings: {
        'input.name': 'name'
    },

    onRender: function() {
        // markdown writer
        this.stickit(this.model);
        return this;
    },

    save: function() {
        return new Promise((resolve, reject) => {
            const context = this.getOption('context');

            let promise;
            if(this.model.get('creating')) {
                promise = DiagramActionCreator.createDirectory(
                    context.projectId,
                    this.model.toJSON()
                );
                promise.then(function(){
                    _.bind(function(){
                        this.model.trigger('destroy', this.model);
                    }, this);
                    resolve();
                }, reject);
            } else {
                promise = DiagramActionCreator.updateDirectory(
                    context.projectId,
                    this.model.id,
                    this.model.toJSON()
                );
                promise.then(function(){
                    _.bind(function(){
                        this.model.set({edit: false});
                    }, this);
                    resolve();
                }, reject);
            }
        });
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/diagram-directory-edit.js